import { render, staticRenderFns } from "./transaction.vue?vue&type=template&id=6bc8208d&scoped=true&"
import script from "./transaction.vue?vue&type=script&lang=js&"
export * from "./transaction.vue?vue&type=script&lang=js&"
import style0 from "./transaction.vue?vue&type=style&index=0&id=6bc8208d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc8208d",
  null
  
)

export default component.exports